// extracted by mini-css-extract-plugin
export default {"offers":"OfferList_offers__+anR4"};